export function makeId(...args) {
  return args.filter(val => val != null).join('-');
}